import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { DropdownModule } from 'primeng/dropdown';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';

import { AdicionarLancamentoCaixaComponent } from './adicionar-lancamento-caixa/adicionar-lancamento-caixa.component';
import { ListarLancamentoCaixaComponent } from './listar-lancamento-caixa/listar-lancamento-caixa.component';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DetalhesLancamentoCaixaComponent } from './detalhes-lancamento-caixa/detalhes-lancamento-caixa.component';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';

@NgModule({
  declarations: [AdicionarLancamentoCaixaComponent,
    DetalhesLancamentoCaixaComponent,
    ListarLancamentoCaixaComponent
  ],
  imports: [
    CommonModule,
    FieldsetModule,
    SpinnerServiceComponent,
    ButtonModule,
    FileUploadModule,
    ReactiveFormsModule,
    DropdownModule,
    StepsModule,
    BadgeModule,
    TableModule,
    PanelModule,
    FormsModule,
    CalendarModule,
    FloatLabelModule,
    ToolbarModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    CheckboxModule,
    InputNumberModule,
    RadioButtonModule,
    ConfirmDialogModule,
    ToolbarSearchComponent
  ],
  exports: [
    ListarLancamentoCaixaComponent,
    DetalhesLancamentoCaixaComponent,
    AdicionarLancamentoCaixaComponent
  ],
})

export class LancamentoCaixaModule { }
